/**
 * @constant ROOT
 * @description Rol raíz del sistema con todos los permisos posibles.
 */
export const ROOT = "root";

/**
 * @constant MASTER
 * @description Rol maestro, posiblemente para configuración global o administración general.
 */
export const MASTER = "master";

/**
 * @constant ADMINISTRATOR
 * @description Rol de administrador con permisos elevados dentro del sistema.
 */
export const ADMINISTRATOR = "administrador";

/**
 * @constant EXAMINER
 * @description Rol asignado a usuarios que aplican o corrigen exámenes.
 */
export const EXAMINER = "examinador";

/**
 * @constant CANDIDATE
 * @description Rol asignado a los usuarios que presentan exámenes.
 */
export const CANDIDATE = "candidato";